module.exports = __webpack_public_path__ + "static/media/card.f44d4221.svg";